import { clsx } from "@/src/utils/clsx"

type DateTimeElementProps = {
    time: string
    className?: string
}

const dateFormatter = new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
})

export default function DateTimeElement({ time, className }: DateTimeElementProps) {
    if (!time) return null
    const dateObj = new Date(time)
    const formatted = new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
    }).format(dateObj)

    return (
        <time
            dateTime={dateObj.toISOString()}
            aria-label={formatted}
            className={clsx(
                className,
                "font-trimRegularNew text-xs uppercase leading-130"
            )}
        >
            {formatted}
        </time>
    )
}
